module.exports = __webpack_public_path__ + "static/media/search-top_min.b0a347df.jpg";